import React, { useState, useEffect } from 'react'
import { useTransition } from 'react-spring'
import { useTranslation } from 'react-i18next';
import { FlexContainer, CheckMark, AlertNegative, XMark, EMail } from 'heliocor-ui'
import 'styled-components/macro'

import { Container, Message, ButtonSnack, Content, Life } from './Snackbar.styles.js'

let id = 0

const contentStyles = (type) => {
    switch(type){
        case 'success': return { color: 'aqua100', icon: CheckMark }
        case 'error': return { color: 'red100', icon: AlertNegative }
        case 'info': return { color: 'blue100', icon: EMail }
        case 'warning': return { color: 'mustard100', icon: AlertNegative }
        default: return { color: 'grey700', icon: false}
    }
}

export function Snackbar({ config = { tension: 125, friction: 20, precision: 0.1 }, timeout = 3000, children }) {

    const { t } = useTranslation()
    const [refMap] = useState(() => new WeakMap())
    const [cancelMap] = useState(() => new WeakMap())
    const [items, setItems] = useState([])

    const transitions = useTransition(items, item => item.key, {
        from: { opacity: 0, height: 0, life: '100%' },
        enter: item => async next => await next({ opacity: 1, height: refMap.get(item).offsetHeight }),
        leave: item => async (next, cancel) => {
            cancelMap.set(item, cancel)
            await next({ life: '0%' })
            await next({ opacity: 0 })
            await next({ height: 0 })
        },
        onRest: item => setItems(state => state.filter(i => i.key !== item.key)),
        config: (item, state) => (state === 'leave' ? [{ duration: timeout }, config, config] : config),
    })

    useEffect(() => void children(msg => setItems(state => [...state, { key: id++, msg }])), [children])

    
    return (
        <Container>
        {transitions.map(({ key, item, props: { life, ...style } }) => (
            <Message key={key} style={style}>
            <Content 
                bgColor={contentStyles(item.msg.type).bgColor}
                color={contentStyles(item.msg.type).color} 
                ref={ref => ref && refMap.set(item, ref)}
            >
                <Life style={{ right: life }} lifeColor={contentStyles(item.msg.type).color}/>
                <FlexContainer padding='0 0 .5rem'>
                    {contentStyles(item.msg.type).icon && 
                        React.createElement(
                            contentStyles(item.msg.type).icon, 
                            {fill: contentStyles(item.msg.type).color, size:'1rem'}
                        )}
                    <p css='padding-left: .5rem; font-size: 12px;'>{t(item.msg.text)}</p>
                </FlexContainer>
                <ButtonSnack
                onClick={e => {
                    e.stopPropagation()
                    cancelMap.has(item) && cancelMap.get(item)()
                }}>
                <FlexContainer padding='0 0 .5rem'>
                <XMark fill='grey100' size='.5rem' />
                </FlexContainer>
                </ButtonSnack>
            </Content>
            </Message>
        ))}
        </Container>
    )
}
